export const Currency = {
  eur: 'Euro &euro;',
  usd: 'US Dollar &dollar;',
  aud: 'Australian Dollar &dollar;',
  cad: 'Canadian Dollar &dollar;',
  gbp: 'Britain Pound &pound;',
  brl: 'Brazilian Real R&dollar;',
  czk: 'Czech Koruna Kč',
  dkk: 'Danish Krone kr',
  mxn: 'Mexican Peso MX&dollar;',
  chf: 'Swiss Franc &#8355;',
  sgd: 'Singapore Dollar S&dollar;',
  vnd: 'Vietnamese dong ₫',
  cop: 'Columbian Peso &dollar;',
  jpy: 'Japanese Yen ¥',
  thb: 'Thai baht ฿',
  clp: 'Chilean Peso &dollar;',
  ars: 'Argentine Peso &dollar;',
};

export const CurrencyHtml = {
  eur: '&euro;',
  usd: '&dollar;',
  aud: '&dollar;',
  cad: '&dollar;',
  gbp: '&pound;',
  brl: 'R&dollar;',
  czk: 'Kč',
  dkk: 'kr',
  mxn: 'MX&dollar;',
  chf: '&#8355;',
  sgd: 'S&dollar;',
  vnd: '₫',
  cop: '&dollar;',
  jpy: '¥',
  thb: '฿',
  clp: '&dollar;',
  ars: '&dollar;',
};
